import { useCallback, useRef, useState, type ReactNode } from 'react';
import {
  PageCommandsDispatchContext,
  PageCommandsStateContext,
  type PageCommand,
  type PageCommandsContributor,
} from './page-commands';

/**
 * Registry mirroring `page-chrome`: sources register under a symbol, the
 * merged list is what the palette reads. Mounted once in `AppShell` above
 * both the routed page tree and `CommandPalette`.
 */
export function PageCommandsProvider({ children }: { children: ReactNode }) {
  const [commands, setCommands] = useState<readonly PageCommand[]>([]);
  const sourcesRef = useRef(new Map<symbol, readonly PageCommand[]>());
  const contribute = useCallback<PageCommandsContributor>((id, next) => {
    if (next && next.length > 0) sourcesRef.current.set(id, next);
    else sourcesRef.current.delete(id);
    setCommands([...sourcesRef.current.values()].flat());
  }, []);

  return (
    <PageCommandsDispatchContext.Provider value={contribute}>
      <PageCommandsStateContext.Provider value={commands}>
        {children}
      </PageCommandsStateContext.Provider>
    </PageCommandsDispatchContext.Provider>
  );
}
